import React, { useState, Fragment } from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";
function SubHeader(props) {
  const { classes, formDetail } = props;
  const navigate = useNavigate();

  return (
    <Fragment>
      {" "}
      <Box className={classes.subHeaderSec}>
        <Box className={classes.subHeaderLeft}>
          <Box
            onClick={() => {
              navigate(-1);
            }}
            className={classes.subHeaderBack}
          >
            <ArrowBackRoundedIcon />
          </Box>
          {formDetail?.isLoading ? (
            <Skeleton
              variant="text"
              sx={{ fontSize: "1rem", width: "180px" }}
            />
          ) : (
            <Typography>{formDetail?.data?.name}</Typography>
          )}
        </Box>
      </Box>
    </Fragment>
  );
}

export default SubHeader;
